import { encodeLink } from '@draftkings/sportsbook-common-utils';

export const buildSGPNavLink = (eventId: string, seoIdentifier: string) => {
    if (seoIdentifier) {
        return `/event/${encodeLink(seoIdentifier)}/${eventId}?sgpmode=true`;
    }

    return `/event/${eventId}?sgpmode=true`;
};
